import {
  isAvailabilityCheckBlock,
  isEpilotCatalogProductsBlock
} from '../../../next/journey'
import {
  BLOCK_TYPE,
  REFERENCED_TYPE,
  type AvailabilityCheckBlock,
  type ReferenceId
} from '../../../types/next'
import type { AvailabilityCheckControlOptions } from '../../../utils'
import { CONTROL_NAME } from '../../../utils'
import type { BlockEnricherHandler, UpBlockHandler } from '../types'
import { newId } from '../utils'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<AvailabilityCheckBlock> = (uischema) => {
  if (uischema.type !== CONTROL_NAME.AVAILABILITY_CHECK) {
    throw new Error('Expected a valid AvailabilityCheck control')
  }

  return {
    id: uischema.id,
    type: BLOCK_TYPE.AVAILABILITY_CHECK,
    settings: {
      ...upCommonSettings(uischema),
      ...(uischema.options as AvailabilityCheckControlOptions)
    },
    // This will (eventually) contain references to product blocks
    references: {}
  }
}

export const enrich: BlockEnricherHandler<AvailabilityCheckBlock> = (
  availabilityBlock,
  steps,
  blocks
) => {
  const sortedBlocks = Object.values(blocks)
    .filter(
      (block) =>
        isAvailabilityCheckBlock(block) || isEpilotCatalogProductsBlock(block)
    )
    .sort((a, b) => {
      const offset = 1_000

      return (
        steps[a.stepId].orderIndex * offset +
        a.orderIndex -
        (steps[b.stepId].orderIndex * offset + b.orderIndex)
      )
    })

  const startingStepRef = steps[availabilityBlock.stepId]

  for (const block of sortedBlocks) {
    const step = steps[block.stepId]

    // Skip blocks that are before the availability block's step
    if (step.orderIndex < startingStepRef.orderIndex) {
      continue
    }

    if (block.type === BLOCK_TYPE.AVAILABILITY_CHECK) {
      if (block.id === availabilityBlock.id) continue
      else break
    }

    const referenceId = newId<ReferenceId>()

    availabilityBlock.references[referenceId] = {
      id: referenceId,
      referenceType: REFERENCED_TYPE.BLOCK,
      referenceId: block.id,
      meaning: 'products'
    }
  }

  return availabilityBlock
}
